module.exports = __webpack_public_path__ + "static/img/vision_catch.e7873e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/application/vision_catch.svg
// module id = zy83
// module chunks = 0